import { render, staticRenderFns } from "./RemarksBox.vue?vue&type=template&id=343b3558&"
import script from "./RemarksBox.vue?vue&type=script&lang=js&"
export * from "./RemarksBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports